<div class="logo-container">
	<img class="img" src="/assets/img/dropbox-sign-plus-procore.jpg" />
</div>

<div class="loading-container" *ngIf="loading">
	<div class="lds-facebook">
		<div></div>
		<div></div>
		<div></div>
	</div>
</div>

<!-- STEP 1 -->
<div [ngClass]="{'hidden': loading || step !== 1}">
	<div *ngIf="loadingSignatures" class="center"><i class="fas fa-spinner fa-spin"></i></div>
	<div *ngIf="signatures.length > 0 && !loadingSignatures && !error" class="form-message-container">
		<app-message [signatureObject]="signatures[0]" [expanded]="true" [readonly]="true"></app-message>
	</div>
	<div *ngIf="signatures.length == 0" class="wizard-title">AUTHENTICATE</div>
	<div class="form-container">
		<div class="form-text-container" *ngIf="accountType == 'connector' && !contextService.clientDetailProcore.usersExist && !error">Everything has been setup successfully. </div>
		<div class="form-text-container" *ngIf="accountType == 'connector' && !contextService.clientDetailProcore.usersExist && !error">Press the Authenticate Dropbox Sign button to link your Procore account with a Dropbox Sign account.</div>

		<div class="form-text-container" *ngIf="accountType == 'shared' && !contextService.clientDetailProcore.usersExist && !error">The invitation has been sent. Please check your inbox and spam/junk folders. ​</div>
		<div class="form-text-container" *ngIf="accountType == 'shared' && !contextService.clientDetailProcore.usersExist && !error">Accept the Dropbox Sign invitation by clicking the link in the email and following the prompts to create your account.​</div>
		<div class="form-text-container" *ngIf="accountType == 'shared' && !contextService.clientDetailProcore.usersExist && !error">After creating your user, click the "Authenticate to Dropbox Sign" button below. ​</div>

		<div class="form-text-container" *ngIf="accountType == '' || contextService.clientDetailProcore.usersExist && !error">Authenticate against Dropbox Sign to start sending signatures.</div>

		<div class="form-text-container" *ngIf="error">Your session has expired. Please re-authenticate with Dropbox Sign.</div>
	</div>
	<div class="button-container" *ngIf="!loading">
		<button (click)="authenenticateDropboxSign()">Authenticate to Dropbox Sign</button>
	</div>
	<div class="form-container bottom" *ngIf="accountType == 'connector' && !contextService.clientDetailProcore.usersExist && !error">
		<div class="form-text-container note"><strong>Note:</strong> To add additional users<span *ngIf="contextService.clientDetailProcore.isTrial"> to the trial</span>, you must complete an extra step to obtain Dropbox App approval. Refer to the <a href="#" target="_blank">Dropbox Sign client app approval steps</a>.​</div>
	</div>
</div>

<!-- STEP 2 -->
<div [ngClass]="{'hidden': loading || step !== 2}">
	<div class="text-container" *ngIf="!error">Refresh Procore after you authenticate with Dropbox Sign.</div>
	<div class="text-container" *ngIf="error">Press continue after you authenticate with Dropbox Sign.</div>
	<div class="button-container" *ngIf="error">
		<button (click)="continue()">Continue</button>
	</div>
</div>